'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.getClassMethods = exports.getKeys = void 0;
var tslib_1 = require('tslib');
function getKeys(source) {
    var props = new Set();
    var obj = source;
    do {
        var keys = Object.getOwnPropertyNames(obj);
        keys.forEach(function (key) {
            props.add(key);
        });
        obj = Object.getPrototypeOf(obj);
    } while (obj && obj !== Object.prototype && obj !== Function.prototype);
    return Array.from(props);
}
exports.getKeys = getKeys;
function getClassMethods(source) {
    var props = getKeys(source);
    var omitMethods = (0, tslib_1.__spreadArray)(
        (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(Object.getOwnPropertyNames(Object.prototype)), false),
        (0, tslib_1.__read)(Object.getOwnPropertyNames(Function.prototype)),
        false
    );
    props = props.filter(function (key) {
        return source[key] instanceof Function && !omitMethods.includes(key) && key[0] !== '_';
    });
    return props;
}
exports.getClassMethods = getClassMethods;
